/* RIOT MOTION — scroll-reveal (visual only). Safe by default:
   no JS = nothing hidden; reduced-motion = disabled; above-fold
   sections render instantly (no LCP/CLS impact); iOS-safe — no
   View Transitions API, transform/opacity only. */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function setup() {
    var sections = document.querySelectorAll('#MainContent > .shopify-section');
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('rm-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    sections.forEach(function (section) {
      if (section.classList.contains('rm-reveal')) return; // already handled
      var rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92) {
        // First viewport: visible immediately, zero animation cost
        section.classList.add('rm-reveal', 'rm-in');
        return;
      }
      section.classList.add('rm-reveal');
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  // Theme editor: re-run when sections are (re)loaded
  document.addEventListener('shopify:section:load', setup);
})();
